import { createContext, Dispatch, SetStateAction } from 'react';

type InboxTotalContextValue = {
  setInboxTotal: Dispatch<SetStateAction<number>>;
  inboxTotal: number;
};

export const inboxTotalContextDefaultValue = {
  inboxTotal: 0,
} as InboxTotalContextValue;

export const InboxTotalContext = createContext(inboxTotalContextDefaultValue);
